import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  gap: 40px;

  @media ${({ theme }) => theme.devices.mobile} {
    gap: 16px;
  }
`;

export const WrapImg = styled.div`
  width: 100%;
  max-width: 400px;
  height: min-content;
  position: relative;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 55%;
    max-width: 55%;
    min-height: 200px;
    border-end-end-radius: 40px;
  }
`;

export const BannerImg = styled.div`
  width: 100%;
  height: max-content;
  min-height: 360px;
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${({ theme }) => theme.colors.grey[800]};
  border-end-end-radius: 100px;
  overflow: hidden;

  @media ${({ theme }) => theme.devices.mobile} {
    min-height: 220px;
    border-end-end-radius: 60px;
  }

  &::after {
    width: 100%;
    height: 100%;
    position: absolute;
    content: '';

    background-image: url(${({ $banner }) => $banner});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
`;

export const ProfileImg = styled.div`
  width: 100%;
  max-width: 140px;
  height: 140px;
  border-radius: 100%;
  position: absolute !important;
  transform: translateY(-70%) translateX(-50%);
  left: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  overflow: hidden;

  @media ${({ theme }) => theme.devices.mobile} {
    max-width: 100px;
    height: 100px;
  }

  &::after {
    width: 100%;
    height: 100%;
    position: absolute;
    content: '';

    background-image: url(${({ $profile }) => $profile});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
`;

export const GroupInfos = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 45%;
  }
`;

export const TopInfos = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const TopInfosTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 12px;
  }

  .text-status {
    display: flex;
    align-items: center;
    gap: 16px;

    @media ${({ theme }) => theme.devices.mobile} {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
    }

    h1 {
      @media ${({ theme }) => theme.devices.mobile} {
        font-size: 28px;
      }
    }
  }
`;

export const TopInfosStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  span {
    color: ${({ theme }) => theme.colors.outher.success};
  }

  > div {
    width: 12px;
    height: 12px;
    border-radius: 100%;
    background-color: ${({ theme }) => theme.colors.outher.success};
  }
`;

export const TopInfosGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
    justify-content: space-between;
  }

  p {
    font-size: 14px;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 12px;
    }
  }
`;

export const ButtonInfos = styled.button`
  display: ${({ $follow }) => ($follow ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  background: transparent;
  position: relative;
  padding: 10px 32px;
  border: none;
  color: ${({ theme }) => theme.colors.grey.white};
  border-radius: 25px;
  z-index: 0;

  p {
    z-index: 1;
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 25px;
    background: ${({ theme }) => theme.colors.gradient.fullX};
    opacity: ${({ $login }) => ($login ? '1' : '0.3')};
    z-index: -2;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 25px;
    padding: 2px;
    background: ${({ theme }) => theme.colors.gradient.fullX};
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: -1;
  }

  &:hover {
    &::before {
      transition: 0.7s;
      opacity: 1;
    }
  }
`;

export const DescriptionInfos = styled.div`
  padding-top: 28px;
  margin-top: 20px;
  margin-bottom: 8px;
  border-top: 1px solid ${({ theme }) => theme.colors.grey[500]};

  @media ${({ theme }) => theme.devices.mobile} {
    padding-top: 8px;
    margin-top: 16px;
    margin-bottom: 4px;
  }
`;

export const BottomInfos = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;

  @media ${({ theme }) => theme.devices.mobile} {
    display: none;
  }
`;

export const InfosNav = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;

  a {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-transform: uppercase;
    text-align: center;
    padding: 8px 2px;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.grey[600]};

    img {
      width: 100%;
      max-width: 24px;
    }

    span {
      font-size: 12px;
    }
    &:hover {
      transition: 0.7s;
      background-color: ${({ theme }) => theme.colors.grey[700]};
    }
  }
`;

export const PrinceInfos = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;
  margin-top: 20px;

  span {
    font-size: 14px;
  }

  h1 {
    margin-top: 2px;
    font-size: 40px;
    font-family: 'Roboto', sans-serif;
    font-weight: 700;
  }

  button {
    background: transparent;
    border: 0;
    color: ${({ theme }) => theme.colors.grey.white};
    text-transform: uppercase;
    font-size: 12px;
    text-decoration: underline;
    padding: 8px;

    &:hover {
      transition: 0.7s;
      opacity: 0.8;
    }
  }
`;

export const UlValues = styled.ul`
  width: 100%;
  display: ${({ $show }) => ($show ? 'flex' : 'none')};
  flex-direction: column;
  list-style: none;
  margin-top: 8px;
  border-radius: 0 0 8px 8px;
  border-top: 3px solid ${({ theme }) => theme.colors.primary.dark};
  overflow: hidden;

  li {
    display: flex;
    padding: 12px 8px;
    background-color: ${({ theme }) => theme.colors.grey[600]};

    &:nth-child(2n + 1) {
      background-color: ${({ theme }) => theme.colors.grey[700]};
    }

    span {
      margin-bottom: -4px;
    }
  }
`;

export const PhoneInfos = styled.div`
  width: 100%;
  margin-top: 12px;

  a {
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    /* padding: 6px 28px 6px 8px; */
    padding: 6px;
    padding-right: 16px;
    width: 100%;
    border-radius: 48px;
    background-color: ${({ theme }) => theme.colors.grey.white};
    color: ${({ theme }) => theme.colors.grey.black};

    img {
      width: 64px;
      height: 64px;
    }

    h1 {
      font-size: 36px;
      font-family: 'Roboto', sans-serif;
      font-weight: 700;
    }

    .row {
      display: flex;
      flex-direction: column;

      span {
        font-family: 'Roboto', sans-serif;
        font-weight: 700;
        font-size: 14px;
        margin-bottom: -2px;
        margin-left: 4px;
      }
    }

    &:hover {
      transition: 0.7s;
      opacity: 0.8;
    }
  }
`;

export const GroupAboutInfos = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  width: fit-content;
  padding-right: 8px;

  & + & {
    padding: 48px 0px 48px 28px;
    border-left: 1px solid ${({ theme }) => theme.colors.grey[500]};
    justify-content: flex-start;
    height: fit-content;
    gap: 16px;

    .underline {
      text-decoration: underline;
    }
  }
`;
